// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38TTS","name":"Header_name___6Wfn","birthday":"Header_birthday__1SGve","skeleton":"Header_skeleton__38Sm2"};